// extracted by mini-css-extract-plugin
module.exports = {"content_container":"Content_content_container__3oIdB","cross_icon":"Content_cross_icon__2wDfd","file_name":"Content_file_name__fdjEI"};